<template>
    <div>
        <Modal size="sm" @close="$emit('close')">
            <template #header>
                <div class="text-gray-600">
                    {{ $t("vue.invite_team_member") }}
                </div>
            </template>

            <template #body>
                <div class="p-6">
                    <TextInput
                        v-model="state.form.email"
                        :placeholder="$t('vue.enter_email_address')"
                        :label="$t('vue.email_address')"
                        :error="getError('email')"
                        required
                        @blur="v$.form.email.$touch()"
                    />

                    <SelectInput
                        ref="SelectInput"
                        v-model="v$.form.role.$model"
                        :placeholder="$t('vue.choose_new_members_team_role')"
                        class="mt-6"
                        :data="data"
                        :error="getError('role')"
                        required
                        :label="$t('vue.new_members_team_role')"
                    >
                    </SelectInput>

                    <!-- <div
                        v-if="
                            v$.form.role.$model &&
                            v$.form.role.$model !== 'viewer'
                        "
                        class="mt-6 text-sm text-gray-500"
                    >
                        Team members with Administrator or Editor roles are
                        billed aditionally according to your plan.
                        Billing starts only when new team member accepts your
                        invitation.
                    </div> -->
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        @click="$emit('close')"
                    >
                        {{ $t("vue.cancel") }}
                    </AtomicButton>

                    <AtomicButton
                        :disabled="loading || v$.form.$invalid"
                        color="yellow"
                        size="md"
                        @click="sendInvite"
                    >
                        {{ $t("vue.invite_team_member_button") }}
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";
import { create } from "@/composables/useNotifications";
import type IInputErrors from "@/types/Atomic/IInputErrors";
import { useTranslations } from "@/composables/useTranslations";

const emit = defineEmits(["close", "update:title"]);

// Get access to translations
const { t } = useTranslations();

const state = reactive({
    form: {
        email: "",
        role: "",
    },
});
const rules = {
    form: {
        email: {
            required,
            email,
        },
        role: {
            required,
        },
    },
};
const v$ = useVuelidate(rules, state);
const errors = ref<IInputErrors>({});
const loading = ref(false);

const data = [
    { title: t("vue.administrator"), value: "admin" },
    { title: t("vue.editor"), value: "editor" },
    { title: t("vue.viewer"), value: "viewer" },
];

const getError = (field: string) => {
    return (
        v$.value.form[field]?.$errors[0]?.$message ||
        errors.value?.[field] ||
        ""
    );
};

const sendInvite = () => {
    v$.value.$touch();
    if (v$.value.form.$error) {
        () => undefined;
    } else {
        loading.value = true;
        router.post(route("members.store"), state.form, {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: t("vue.invitation_sent"),
                    type: "info",
                });
                emit("close");
            },
            onError: (err) => {
                create({
                    title: t("vue.invitation_not_sent"),
                    text: t("vue.error_sending_invitation"),
                    type: "error",
                });
                errors.value = err;
            },
            onFinish: () => {
                loading.value = false;
            },
        });
    }
};
</script>

<style></style>
